import { PublicKey } from "@solana/web3.js";
import { makeDSTProgram } from "./makeDSTProgram.js";
import { BN, Provider } from "@coral-xyz/anchor";

/**
 * Burning DST tokens is as follows:
 *
 * 1. Create a Burn instruction
 * 2. Send the transaction
 *
 * @param provider
 */
export function burnDST({
  dst,
  tokenMint,
  sourceDstAccount,
  sourceAuthority,
  destinationVsolAccount,
  dstVsolReserves,
  burnAmount,
  provider,
}: {
  dst: PublicKey;
  tokenMint: PublicKey;
  sourceDstAccount: PublicKey;
  sourceAuthority: PublicKey;
  destinationVsolAccount: PublicKey;
  dstVsolReserves: PublicKey;
  burnAmount: number;
  provider?: Provider;
}) {
  const program = makeDSTProgram(provider);
  const result = program.methods.burnDst(new BN(burnAmount)).accountsPartial({
    dst,
    tokenMint,
    sourceDstAccount,
    sourceAuthority,
    destinationVsolAccount,
    vsolReserves: dstVsolReserves,
  });

  return result;
}
